import script from "./LoadingOverlay.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingOverlay.vue?vue&type=script&setup=true&lang=js"

import "./LoadingOverlay.vue?vue&type=style&index=0&id=2b5d2976&lang=css"

const __exports__ = script;

export default __exports__